<div class="modal-header">
  <h4 class="modal-title">{{my_modal_title}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="container">
    <p>Cargar archivo de firmantes...</p> 
    <p>El archivo debe contener la siguientes columnas "Nombre" "Email" "RFC" y podra estar en formato Excel o CSV. <a href="assets/files/Lista_Firmantes.xlsx">Haz click aqui para descargar el template.</a> </p>

    <!-- Drag & Drop Area -->
    <div class="file-drop-area"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)">
       <p>Arrastra y suelta tu archivo aqui ...</p>
       <input type="file" (change)="onFileChange($event)" hidden #fileInput>
       <button (click)="fileInput.click()">O haz click aqui para seleccionar</button>
     </div>

      <!-- Additional Modal Content -->
      <div *ngIf="jsonData.length">
        <h3>Datos leidos:</h3>
        <table>
          <thead>
            <tr>
              <th>Full Name</th>
              <th>Email</th>
              <th>RFC</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of jsonData">
              <td>{{ row.fullName }}</td>
              <td>{{ row.email }}</td>
              <td>{{ row.rfc }}</td>
            </tr>
          </tbody>
        </table>
      </div>
     

  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="closeModalWithoutResult()">Cerrar</button>
  <div *ngIf="jsonData.length">
    <button type="button" class="btn btn-success btn-outline-dark" (click)="closeModalWithResult()">Continuar</button>
  </div>
</div>
